// extracted by mini-css-extract-plugin
module.exports = {"LoaderHolder":"Loader_LoaderHolder__3UbMp","LoaderBar":"Loader_LoaderBar__-DbE5","Loader":"Loader_Loader__1C5lT"};